module.exports = __webpack_public_path__ + "img/28_68.7853b9db.png";